import { default as indexYdkP3yexm5Meta } from "/app/ib-rewards/pages/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/ib-rewards/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/app/ib-rewards/pages/index.vue")
  }
]